
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom'
import Home from './components/Home'
import Wallet from './Wallet'
import { ReactComponent as LogoSvg } from './logo.svg';

import './LandingApp.css';

function LandingApp() {
  return (
    <div>
      <LogoSvg />
      <Router>
          <Switch>
            <Route path={'/app'} component={Wallet}></Route>

            <Route path="/">
            <Home />
          </Route>
          <Route path="/">
            <Wallet />
          </Route>

          </Switch>
      </Router>
   </div>
  );
}

export default LandingApp;
